



















import Vue from 'vue';
import LastFm from '@/api/LastFm';
export default Vue.extend({
  computed: {
    userName(): string {
      return this.$store.state.lfmApi.userName;
    },
    lastwaveUrl(): string {
      const url = `https://savas.ca/lastwave#/?customrange=Last%202%20weeks&username=${this.userName}`;
      return url;
    },
  },
});
